module.exports = __webpack_public_path__ + "img/145.31caede7.jpg";